var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCloud4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1284,
    height: 654,
    viewBox: "0 0 1284 654",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1146_1269)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-10 27.5516C-10 27.5516 2.8192 44.344 4.37257 50.5575C4.37257 50.5575 51.9378 42.1693 80.8465 57.3922C109.755 72.6152 130.897 94.3783 131.518 123.614C131.518 123.614 153.593 130.449 158.252 144.445L1102.05 144.756C1102.05 144.756 1109.51 140.096 1113.55 140.096L1118.52 137.611C1118.52 137.611 1125.16 112.675 1147.66 114.163C1147.66 114.163 1150.65 84.0937 1172.23 67.0394C1172.23 67.0394 1197.81 48.579 1210.3 45.4558C1210.3 45.4558 1218.54 19.8829 1238.42 9.94144C1258.3 -2.17902e-05 1287 0 1287 0V169.871H-10V27.5516Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-10 190H1287V208.577H-10V190Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-10 229H1287V238.12H-10V229Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-10 259H1287V263.391H-10V259Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1146_1269"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3840,
    height: 654,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud4);
export default __webpack_public_path__ + "static/media/cloud_4.9ef5b0868738c8cb5c0cf6ca1366379d.svg";
export { ForwardRef as ReactComponent };